import { render, staticRenderFns } from "./OrderedItems.vue?vue&type=template&id=ca003b2a&"
import script from "./OrderedItems.vue?vue&type=script&lang=js&"
export * from "./OrderedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports